{
  "archives": {
    "ShardX-Fingerprints.zip": "de9a683b423a3d123572468e36cf896f",
    "ShardX-Linux.zip": "30b0d584d557380dd646600f1c88b09d-25",
    "ShardX-Mac-arm64.zip": "dd3da40f0bfb342757b3a270a77d9718-20",
    "ShardX-Widevine-Linux.zip": "9b7d2697bc8ede2bd9fe72ccaaa2f15f-3",
    "ShardX-Widevine-Mac-arm64.zip": "c54f3fb0b47c47d8f4663ddd3b1f2cf4",
    "ShardX-Widevine-Win.zip": "8852779330edb7ac2096e0d21dc3afb5",
    "ShardX-Windows.zip": "dc9da8907d40d91e8b0e964ed7dc43c7-24"
  },
  "sha256": {
    "ShardX-Fingerprints.zip": "f50d5a853dd362db93dfbc76deb236cc3a5847c941c88521f2ce43c85b7f3b16",
    "ShardX-Linux.zip": "8023c569579aec76069e00deb6e9c26c4587645dff4a9247035211a9337721be",
    "ShardX-Mac-arm64.zip": "48f6ae0ab4c6e20772169c6b988283e75b700655b6724c84107c181e241651fb",
    "ShardX-Widevine-Linux.zip": "44fb1a3afd884d650904b88637eef8cede162ea5d302292a7b8813deafb751dc",
    "ShardX-Widevine-Mac-arm64.zip": "5c2f78dd705e8f842455136eeeb358805cc721288cd268e079676a557eeabf92",
    "ShardX-Widevine-Win.zip": "8b32e3627b998964aa53670f85756c7bc2127780c2aa5cc06fbf4fd0bcb07862",
    "ShardX-Windows.zip": "7934e31bf359f7a8df37f387af94e9aa612385d4c4ff7138a3e1a4abb7391bff"
  },
  "sizes": {
    "ShardX-Fingerprints.zip": 477073,
    "ShardX-Linux.zip": 207083643,
    "ShardX-Mac-arm64.zip": 161482082,
    "ShardX-Widevine-Linux.zip": 17237587,
    "ShardX-Widevine-Mac-arm64.zip": 17016662,
    "ShardX-Widevine-Win.zip": 17909215,
    "ShardX-Windows.zip": 199969358
  },
  "chromium_version": "152.0.7977.65",
  "engine_build": "2",
  "min_launcher_version": "2.0.1",
  "grease_brand": "Not?A_Brand",
  "grease_version": "24",
  "tls": {
    "signature_algorithms": [2308, 2309, 2310, 1027, 2052, 1025, 1283, 2053, 1281, 2054, 1537],
    "cipher_suites": [4865, 4866, 4867, 49195, 49199, 49196, 49200, 52393, 52392, 49171, 49172, 156, 157, 47, 53]
  },
  "revision": 6
}
